import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import ClickMatchFamilyNormalizer from "./ClickMatchFamilyNormalizer";
export default class ClickMatchFamilyNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new ClickMatchFamilyNormalizer(),
        ];
    }
}
